import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Footer.css";

import bookly from "../assets/Footer/logo.png";
import visa from "../assets/Footer/pay-visa.svg";
import mastercard from "../assets/Footer/pay-mastercard.svg";
import bkash from "../assets/Footer/pay-bkash.svg";
import nagad from "../assets/Footer/pay-nagad.svg";

class Footer extends Component {

  constructor(props) {
    super(props);

    this.PUBLIC_BASE = (axios.defaults.baseURL || window.location.origin).replace(/\/api\/?$/, "");

    this.state = {
      
      website_name: "",
      description: "",
      website_logo: "",

      whatsapp_number: "",
      address: "",
      phone: "",
      email: "",

      social_link_1: "",
      social_link_2: "",
      social_link_3: "",
      social_link_4: "",

      powered_by: "",

      loading: true,
    };
  }

  componentDidMount() {
    this.fetchFooterData();
  }

  getImageUrl = (imagePath) => {
    if (!imagePath) {
      return "";
    }

    if (
      imagePath.startsWith("http://") ||
      imagePath.startsWith("https://")
    ) {
      return imagePath;
    }

    const cleanPath = imagePath.replace(/^\/+/, "");

    return `${this.PUBLIC_BASE}/${cleanPath}`;
  };

  fetchFooterData = async () => {
    try {
      const [themeRes, settingRes] = await Promise.all([
        axios.get("/theme_customizable"),
        axios.get("/setting"),
      ]);

      const theme = themeRes?.data?.data || {};
      const setting = settingRes?.data?.data || {};

      const websiteLogo = theme.website_logo || "";

      this.setState({
        website_name: theme.website_name || "",
        description: theme.description || "",
        website_logo: websiteLogo,

        whatsapp_number: theme.whatsapp_number || "",
        address: theme.address || "",
        phone: theme.phone || "",
        email: theme.email || "",

        social_link_1: theme.social_link_1 || "",
        social_link_2: theme.social_link_2 || "",
        social_link_3: theme.social_link_3 || "",
        social_link_4: theme.social_link_4 || "",

        powered_by: setting.powered_by || "© 2026 Bookly. All rights reserved.",

        loading: false,
      });
    } catch (error) {
      console.error("Footer fetch error:", error);

      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const {
      website_name,
      description,
      website_logo,
      email,
      phone,
      address,
      powered_by,
      social_link_1,
      social_link_2,
      social_link_3,
      social_link_4,
      loading,
    } = this.state;

    /**
     * API logo
     */
    const apiLogo = this.getImageUrl(website_logo);

    /**
     * Use API logo if available.
     * Otherwise use local Bookly logo.
     */
    const finalLogo = apiLogo || bookly;

    return (
      <>
        <footer
          className="footer-dark bg-black text-white py-5"
          style={{ backgroundColor: "#101010" }}
        >
          <div className="container-fluid px-lg-5">
            {/* =====================================================
                TOP SECTION
            ====================================================== */}
            <div className="row g-4 justify-content-between pb-4">
              {/* =================================================
                  BRAND
              ================================================== */}
              <div className="col-lg-4 col-md-12 pe-lg-5">
                <Link
                  to="/"
                  className="d-flex align-items-center gap-2 mb-3 text-decoration-none"
                >
                  <img
                    src={finalLogo}
                    alt={website_name || "Bookly"}
                    style={{
                      width: "220px",
                      marginLeft: "-50px",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      /**
                       * If API logo fails,
                       * fallback to local logo.
                       */
                      if (e.currentTarget.src !== bookly) {
                        e.currentTarget.src = bookly;
                      }
                    }}
                  />
                </Link>

                <p className="brand-description mb-4">
                  {description ||
                    "No matter where your adventures take you, there's always a welcoming space waiting for you."}
                </p>

                {/* =============================================
                    CONTACT DETAILS
                ============================================== */}
                <div className="contact-details d-flex flex-column gap-2">
                  {/* Phone */}
                  {phone && (
                    <div className="d-flex align-items-center gap-3">
                      <i className="bi bi-telephone"></i>

                      <a
                        href={`tel:${phone}`}
                        className="text-white text-decoration-none"
                      >
                        {phone}
                      </a>
                    </div>
                  )}

                  {/* Email */}
                  {email && (
                    <div className="d-flex align-items-center gap-3">
                      <i className="bi bi-envelope"></i>

                      <a
                        href={`mailto:${email}`}
                        className="text-white text-decoration-none"
                      >
                        {email}
                      </a>
                    </div>
                  )}

                  {/* Address */}
                  {address && (
                    <div className="d-flex align-items-start gap-3">
                      <i className="bi bi-geo-alt mt-1"></i>

                      <span>{address}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* =================================================
                  FOOTER LINKS
              ================================================== */}
              <div className="col-lg-7 col-md-12">
                <div className="row g-4">
                  {/* ===========================================
                      EXPLORE
                  ============================================ */}
                  <div className="col-6 col-sm-3">
                    <h5 className="footer-heading">Explore</h5>

                    <ul className="list-unstyled footer-links">
                      <li>
                        <Link to="#">Stays</Link>
                      </li>

                      <li>
                        <Link to="#">Villas</Link>
                      </li>

                      <li>
                        <Link to="#">Destinations</Link>
                      </li>

                      <li>
                        <Link to="#">Event Spaces</Link>
                      </li>
                    </ul>
                  </div>

                  {/* ===========================================
                      COMPANY
                  ============================================ */}
                  <div className="col-6 col-sm-3">
                    <h5 className="footer-heading">Company</h5>

                    <ul className="list-unstyled footer-links">
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>

                      <li>
                        <Link to="/TermsandConditions">
                          Terms &amp; Conditions
                        </Link>
                      </li>

                      <li>
                        <Link to="/PrivacyPolicy">
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/RefundPolicy">
                          Refund Policy
                        </Link>
                      </li>
                      
                    </ul>
                  </div>

                  {/* ===========================================
                      SUPPORT
                  ============================================ */}
                  <div className="col-6 col-sm-3">
                    <h5 className="footer-heading">Support</h5>
                    <ul className="list-unstyled footer-links">
                      <li>
                        <Link to="/contact">Help Center</Link>
                      </li>
                      <li>
                        <Link to="/blogs">Blogs</Link>
                      </li>
                      <li>
                        <Link to="#">FAQ</Link>
                      </li>
                    </ul>
                  </div>

                  {/* ===========================================
                      PRODUCTS
                  ============================================ */}
                  <div className="col-6 col-sm-3">
                    <h5 className="footer-heading">Products</h5>

                    <ul className="list-unstyled footer-links">
                      <li>
                        <Link to="#">Upcoming</Link>
                      </li>

                      <li>
                        <Link to="#">Trending</Link>
                      </li>

                      <li>
                        <Link to="#">New</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <hr className="footer-divider my-4" />
            <div className="row align-items-center g-3">
              <div className="col-md-5 text-center text-md-start copyright-text">
                {powered_by ||
                  "© 2026 Bookly. All rights reserved."}
              </div>
              <div className="col-md-7 d-flex flex-wrap align-items-center justify-content-center justify-content-md-end gap-3 gap-lg-4">
                <span className="accepted-payments-text">
                  Accepted payments
                </span>
                <div className="d-flex align-items-center gap-2">
                  {/* Visa */}
                  <div className="payment-badge">
                    <img
                      className="footer_payment_icons"
                      src={visa}
                      alt="Visa"
                    />
                  </div>
                  <div className="payment-badge">
                    <img
                      className="footer_payment_icons"
                      src={mastercard}
                      alt="Mastercard"
                    />
                  </div>
                  <div className="payment-badge">
                    <img
                      className="footer_payment_icons"
                      src={bkash}
                      alt="bKash"
                    />
                  </div>

                  {/* Nagad */}
                  <div className="payment-badge">
                    <img
                      className="footer_payment_icons"
                      src={nagad}
                      alt="Nagad"
                    />
                  </div>
                </div>

                {/* ==========================================
                    SOCIAL ICONS
                =========================================== */}
                <div className="d-flex align-items-center gap-3 ms-lg-2 social-icons">
                  {/* Facebook */}
                  {social_link_1 && (
                    <a
                      href={social_link_1}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <i className="bi bi-facebook"></i>
                    </a>
                  )}

                  {/* LinkedIn */}
                  {social_link_2 && (
                    <a
                      href={social_link_2}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                    >
                      <i className="bi bi-linkedin"></i>
                    </a>
                  )}

                  {/* YouTube */}
                  {social_link_3 && (
                    <a
                      href={social_link_3}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="YouTube"
                    >
                      <i className="bi bi-youtube"></i>
                    </a>
                  )}

                  {/* Twitter / X */}
                  {social_link_4 && (
                    <a
                      href={social_link_4}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Twitter X"
                    >
                      <i className="bi bi-twitter-x"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
